<template>
<div>
    <section>

        <div class="top-nav-div">
            <div class="top-nav-elements">
                <a href="#" class="link-block-42 w-inline-block">
                    <img :src="require('@/assets/images/NewSelf_Logo.png')" sizes="(max-width: 479px) 100vw, 84.03125px" loading="lazy" class="image-294">
                </a>
                <div class="form-nav-div">
                    <a href="#" @click.prevent="questionId > 1 ? questionId-- : null" class="back-link w-inline-block">
                        <div class="text-block-507">&lt;-</div>
                    </a>
                    <div class="form-progress-div">
                        <div>
                            <div class="text-block-508">Step <strong>{{ questionId }}</strong> of <strong>9</strong></div>
                        </div>
                        <div class="form-precent-div">
                            <div class="text-block-509"><strong>{{ Math.round(((questionId - 1) / 9) * 100) }}%</strong> Complete</div>
                        </div>
                    </div>
                </div>
                <div class="div-block-1442">
                    <div class="text-block-505"></div>
                </div>
            </div>
        </div>

    </section>

    <section class="section-7">
        <div class="questions-div">
            <!-- Treatment Goals -->
            <div class="question-container" v-if="questionId === 1">
                <div class="question-div-2">
                    <div class="text-block-513">We would like to know your goals</div>
                    <div class="form-subs">Select all that apply</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="validateGoals">
                            <label v-for="goal in treatmentGoals" :key="goal.id" class="checkbox-field-15 w-clearfix">
                                <input type="checkbox" v-model="patient.goals" :value="goal.id" class="w-checkbox-input checkbox-11">
                                <span class="checkbox-label-12 w-form-label">{{ goal.label }}</span>
                            </label>
                            <div class="form-group" v-if="patient.goals.includes('other')" >
                                    <textarea 
                                        v-model="patient.otherGoal"
                                        class="textarea w-input" 
                                        placeholder="Please describe your goals"
                                        required></textarea>
                                </div>
                            <input type="submit" class="form-button w-button" value="Next ->">
                        </form>
                    </div>
                </div>
            </div>

            <!-- Cardiovascular Health Rating -->
            <div class="question-container" v-if="questionId === 2">
                <div class="question-div-2">
                    <div class="text-block-513">On a scale of 1-5, how would you rate your average cardiovascular health?</div>
                    <div class="felix-form-block w-form">
                        <form>
                            <a href="#" v-for="n in 5" :key="n" class="link-block-30 w-inline-block" @click.prevent="setRating('cardiovascularRating',n)">
                                <div>
                                    <div class="text-block-545">{{ n }} {{ n === 1 ? '(poor)' : n === 5 ? '(excellent)' : '' }}</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                        </form>
                    </div>
                </div>
            </div>

            <!-- Strength Rating -->
            <div class="question-container" v-if="questionId === 3">
                <div class="question-div-2">
                    <div class="text-block-513">On a scale of 1-5, how would you rate your strength?</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="nextQuestion">
                            <a href="#" v-for="n in 5" :key="n" class="link-block-30 w-inline-block" @click.prevent="setRating('strengthRating',n)">
                                <div>
                                    <div class="text-block-545">{{ n }} {{ n === 1 ? '(poor)' : n === 5 ? '(excellent)' : '' }}</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                        </form>
                    </div>
                </div>
            </div>

            <!-- BMI Calculation -->
            <div class="question-container" v-if="questionId === 4">
                <div class="question-div-2">
                    <div class="text-block-513">What is your height and weight?</div>
                    <div class="form-subs">We'll use this to determine your Body mass Index (BMI) for diagnosis.
                        remember, BMI is a measure of size - not health</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="checkSexAndMoveNext">
                            <div class="div-block-1478 mobile-entry form _2 height top">
                                <input class="text-field-44 height w-input" v-model="patient.height.feet" @keyup="calculateBMI" placeholder="Feet" type="number" required>
                                <input class="text-field-44 height w-input" v-model="patient.height.inches" @keyup="calculateBMI" placeholder="Inches" type="number" required>
                            </div>
                            <div class="div-block-1479 mobile-entry form _2 weight">
                                <input class="text-field-45 weight w-input" v-model="patient.weight" @keyup="calculateBMI" placeholder="Weight in pounds" type="number" required>
                            </div>
                            <div v-if="patient.bmi" class="bmi-result">
                                Your BMI: {{ patient.bmi.toFixed(1) }}
                            </div>
                            <input type="submit" class="form-button w-button" value="Next ->">
                        </form>
                    </div>
                </div>
            </div>

            <!-- Pregnancy Status -->
            <div class="question-container" v-if="questionId === 5">
                <div class="question-div-2">
                    <div class="text-block-513">Are you pregnant or breastfeeding?</div>
                    <div class="felix-form-block w-form">
                        <form>
                            <a href="#" v-for="option in pregnancyOptions" :key="option.id" @click.prevent="checkPregnancyStatus(option.label)" class="link-block-30 w-inline-block">
                                <div>
                                    <div class="text-block-545">{{ option.label }}</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                        </form>
                    </div>
                </div>
            </div>

            <!-- Substance Use -->
            <div class="question-container" v-if="questionId === 6">
                <div class="question-div-2">
                    <div class="text-block-513">Do you use opiates or binge drink alcohol?</div>
                    <div class="felix-form-block w-form">
                        <form>
                            <a href="#" v-for="option in substanceOptions" @click.prevent="checkSubstanceUse(option.label)" :key="option.id" class="link-block-30 w-inline-block">
                                <div>
                                    <div class="text-block-545">{{ option.label }}</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                        </form>
                    </div>
                </div>
            </div>

            <!-- Medical Conditions -->
            <div class="question-container" v-if="questionId === 7">
                <div class="question-div-2">
                    <div class="text-block-513">Do you currently have, or have you ever been diagnosed with, any of the following conditions?</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="validateMedicalConditions">
                            <div class="checkbox-options">
                                <label v-for="condition in medicalConditions" :key="condition.id" class="checkbox-field-15 w-clearfix">
                                    <input type="checkbox" v-model="patient.conditions" :value="condition.id" class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label">{{ condition.label }}</span>
                                </label>
                            </div>
                            <input type="submit" class="form-button w-button" value="Next ->">
                        </form>
                    </div>
                </div>
            </div>

            <!-- Medications -->
            <div class="question-container" v-if="questionId === 8">
                <div class="question-div-2">
                    <div class="text-block-513">Do you take any of the following medications?</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="validateMedications">
                            <div class="checkbox-options">
                                <label v-for="med in medications" :key="med.id" class="checkbox-field-15 w-clearfix">
                                    <input type="checkbox" v-model="patient.currentMedications" :value="med.id" class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label">{{ med.label }}</span>
                                </label>
                            </div>
                            <input type="submit" class="form-button w-button" value="Next ->">
                        </form>
                    </div>
                </div>
            </div>

            <!-- Informed Consent -->
            <div class="question-container" v-if="questionId === 9">
                <div class="question-div-2">
                    <div class="text-block-513">Informed Consent</div>
                    <div class="consent-text" v-html="consentText"></div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="submitForm">
                            <div class="consent-options">
                                <label class="radio-option">
                                    <input type="radio" v-model="patient.consent" value="accept" required>
                                    <span>&nbsp;I have read the consent and understand the content, I wish to proceed</span>
                                </label>
                                <label class="radio-option">
                                    <input type="radio" v-model="patient.consent" value="decline">
                                    <span>&nbsp;I have read the consent and I do not wish to move forward</span>
                                </label>
                            </div>
                            <button type="submit" class="form-button w-button" :disabled="loading">
                                {{ loading ? 'Submitting...' : 'Complete Screening' }}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div style="height: 320px;"></div>
</div>
</template>

<script>
export default {
    name: 'SermorelinForm',
    data() {
        return {
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            questionId: 1,
            loading: false,
            patient: {
                goals: [],
                otherGoal: '',
                cardiovascularRating: null,
                strengthRating: null,
                sex: null,
                height: {
                    feet: '',
                    inches: ''
                },
                weight: '',
                bmi: null,
                pregnancyStatus: null,
                substanceUse: null,
                conditions: [],
                currentMedications: [],
                consent: 'accept'
            },
            treatmentGoals: [{
                    id: 'weight',
                    label: 'Maintain a healthy weight'
                },
                {
                    id: 'metabolic',
                    label: 'Improve metabolic health'
                },
                {
                    id: 'cardiovascular',
                    label: 'Improve cardiovascular health'
                },
                {
                    id: 'quality',
                    label: 'Improve overall quality of life'
                },
                {
                    id: 'mood',
                    label: 'Improve mood'
                },
                {
                    id: 'energy',
                    label: 'Increase energy'
                },
                {
                    id: 'muscle',
                    label: 'Improve muscle tone'
                },
                {
                    id: 'other',
                    label: 'Other'
                }
            ],
            pregnancyOptions: [{
                    id: 'breastfeeding',
                    label: 'I am breastfeeding'
                },
                {
                    id: 'pregnant',
                    label: 'I am pregnant'
                },
                {
                    id: 'planning',
                    label: 'I plan on becoming pregnant'
                },
                {
                    id: 'none',
                    label: 'None of these apply to me'
                }
            ],
            substanceOptions: [{
                    id: 'binge',
                    label: 'Yes, I binge drink (4-5+ drinks on an occasion per CDC guidelines)'
                },
                {
                    id: 'opiates',
                    label: 'Yes, I use opiates'
                },
                {
                    id: 'both',
                    label: 'I do both'
                },
                {
                    id: 'none',
                    label: 'None of these apply to me'
                }
            ],
            medicalConditions: [{
                    id: 'none',
                    label: 'None of these apply to me'
                },
                {
                    id: 'cancer',
                    label: 'Any Active Cancer'
                },
                {
                    id: 'thyroid',
                    label: 'Hypothyroidism/Underactive Thyroid'
                }
            ],
            medications: [{
                    id: 'cox',
                    label: 'COX inhibitors (Aspirin, indomethacin)'
                },
                {
                    id: 'muscarinic',
                    label: 'Muscarinic antagonist (atropine)'
                },
                {
                    id: 'somatostatin',
                    label: 'Somatostatin-containing medications (clonidine and levodopa)'
                },
                {
                    id: 'propylthiouracil',
                    label: 'Propylthiouracil'
                },
                {
                    id: 'none',
                    label: 'None of the above'
                }
            ],
            consentText: `Sermorelin is a medication that may be prescribed to support your metabolism, though it is not an FDA-approved product for this specific use. Its application for metabolism support is considered off-label, meaning it is prescribed by your healthcare provider despite not being specifically approved by the FDA for this purpose. The purpose of this consent form is to ensure that you understand the reasons for using sermorelin, the potential benefits and risks, the monitoring plan, and your responsibilities during treatment. Please read this document carefully. <br/><br/>
                            Sermorelin is being considered as a treatment option to potentially improve your symptoms by acting as a synthetic analogue of growth hormone-releasing hormone (GHRH), which stimulates the secretion of growth hormone (GH). Growth hormone plays a critical role in growth, body composition, cell repair, and metabolism. By promoting the natural production of GH, sermorelin may enhance muscle growth, improve body composition, boost energy levels, and support overall physical performance. It is commonly used for purposes like weight loss, muscle gain, and anti-aging therapy.<br/><br/>
                            As previously mentioned, the use of sermorelin to increase growth hormone levels is considered off-label. While legally prescribed, its use differs from the original FDA-approved indications. Like any medication, sermorelin comes with potential risks and side effects. Some of the side effects include injection site reactions such as pain, swelling, and redness, as well as headaches, flushing, dizziness, and nausea. More serious but less common risks include exacerbation of undiagnosed cancers, significant changes in blood pressure, increased intracranial pressure, and severe allergic reactions.<br/><br/>
                            There are concerns regarding the long-term use of sermorelin and its potential link to increased cancer risk. While there is no definitive evidence directly linking sermorelin to cancer, some studies suggest that prolonged use of growth hormone therapies could potentially increase the risk of certain cancers due to hormonal imbalances. Since sermorelin stimulates the production of growth hormone, it may influence the development of cancerous cells in individuals who are susceptible.<br/><br/>
                            To ensure safety and effectiveness, regular monitoring is required during treatment with sermorelin. This includes blood tests every six months to monitor growth hormone levels, regular symptom assessments to evaluate the medication’s effectiveness, and follow-up visits to discuss progress, any side effects, and adjustments to the treatment plan as necessary.<br/><br/>
                            You have the right to discuss and consider alternative treatments with your healthcare provider. These alternatives may include lifestyle modifications such as exercise, diet, sleep hygiene, and stress management. As a patient, you are responsible for attending all scheduled follow-up appointments, reporting any side effects or new symptoms to your healthcare provider, adhering to the prescribed dosing regimen, and undergoing all required laboratory tests as part of the monitoring plan.<br/><br/>
                            By signing this consent form, you confirm that you have read and understood the information provided. You understand the potential risks and benefits of using sermorelin, as well as its off-label nature, and agree to adhere to the monitoring plan and report any concerns or side effects to your healthcare provider. By signing below, you voluntarily consent to the use of sermorelin for the treatment of your symptoms.<br/><br/>
                        ` // Add the full consent text here
        }
    },
    methods: {
        setSexOnUser(){
            let temp = this.$store.getters.user;
            try{
                this.patient.weight = temp.weight;
                const totalInches = parseInt(temp.height_inch) || 0
                this.patient.height.feet = Math.floor(totalInches / 12)
                this.patient.height.inches = totalInches % 12;
                const bmi = (temp.weight * 703) / (totalInches * totalInches)
                this.patient.bmi = bmi
            }catch(error){
                console.log("unable to set height and weight")
            }

            if(temp.gender!=null || temp.gender!==''){
                this.patient.sex = temp.gender;
            }
        },
        checkSexAndMoveNext(){
            if(this.patient.sex ==='Female'){
                this.patient.pregnancyStatus= "none"
                this.nextQuestion();
            }else{
                this.questionId+=2;
            }
        },
        setRating(field, value) {
            this.patient[field] = value + value === 1 ? '(poor)' : value === 5 ? '(excellent)' : '';
            this.nextQuestion();
        },
        validateGoals() {
            if (this.patient.goals.length === 0) {
                alert('Please select at least one goal')
                return
            }
            if (this.patient.goals.includes('other') && !this.patient.otherGoal) {
                alert('Please specify your other goal')
                return
            }
            this.nextQuestion()
        },
        calculateBMI() {
            const heightInInches = (parseInt(this.patient.height.feet) * 12) + parseInt(this.patient.height.inches)
            const weightInPounds = parseInt(this.patient.weight)
            this.patient.bmi = (weightInPounds * 703) / (heightInInches * heightInInches)
            
        },
        checkPregnancyStatus(value) {
            this.patient.pregnancyStatus = value;
            if (this.patient.pregnancyStatus !== 'None of these apply to me') {
                this.disqualifyPatient('pregnancy')
            } else {
                this.nextQuestion()
            }
        },
        checkSubstanceUse(value) {
            this.patient.substanceUse = value;
            if (this.patient.substanceUse !== 'None of these apply to me') {
                this.disqualifyPatient('substance')
            } else {
                this.nextQuestion()
            }
        },
        validateMedicalConditions() {
            if (this.patient.conditions.includes('cancer')) {
                this.disqualifyPatient('cancer')
                return
            }
            this.nextQuestion()
        },
        validateMedications() {
            // If they select any medication other than 'none', show warning
            if (this.patient.currentMedications.length > 0 &&
                !this.patient.currentMedications.includes('none')) {
                this.showMedicationWarning()
            } else {
                this.nextQuestion()
            }
        },
        showMedicationWarning() {
            const proceed = confirm(
                'The medications you selected may interact with Sermorelin. ' +
                'Your healthcare provider will review this during your consultation. ' +
                'Would you like to proceed?'
            )
            if (proceed) {
                this.nextQuestion()
            }
        },
        nextQuestion() {
            this.questionId++
            this.scrollToTop()
        },
        disqualifyPatient(reason) {
            let message = 'Based on your responses, Sermorelin may not be appropriate for you at this time. '
            switch (reason) {
                case 'pregnancy':
                    message += 'Sermorelin is not recommended during pregnancy or breastfeeding.'
                    break
                case 'substance':
                    message += 'Substance use may interfere with the safety and effectiveness of Sermorelin.'
                    break
                case 'cancer':
                    message += 'Active cancer is a contraindication for Sermorelin therapy.'
                    break
                default:
                    message += 'Please consult with your healthcare provider for alternative options.'
            }
            this.$router.push(`/sorry?message=${message}`)
            
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        },
        async submitForm() {
            if (this.patient.consent === 'decline') {
                this.$router.push({ name: 'declined' });
                return;
            }

            this.loading = true;
            try {
                const formattedData = {
                    formObj: {
                        consentsSigned: this.patient.consent === 'accept',

                        // Format Q&A pairs with full questions and available options
                        Q1: `We would like to know your goals. Select all that apply. Available Options: ${this.treatmentGoals.map(goal => goal.label).join(', ')}`,
                        A1: this.formatGoals(),

                        Q2: "On a scale of 1-5, how would you rate your average cardiovascular health? (1=poor, 5=excellent)",
                        A2: `${this.patient.cardiovascularRating}`,

                        Q3: "On a scale of 1-5, how would you rate your strength? (1=poor, 5=excellent)",
                        A3: `${this.patient.strengthRating}`,

                        Q4: "BMI Calculation",
                        A4: `Height: ${this.patient.height.feet}'${this.patient.height.inches}", Weight: ${this.patient.weight} lbs, BMI: ${this.patient.bmi?.toFixed(1)}`,

                        Q5: `Are you pregnant or breastfeeding? Available Options: ${this.pregnancyOptions.map(opt => opt.label).join(', ')}`,
                        A5: this.patient.pregnancyStatus,

                        Q6: `Do you use opiates or binge drink alcohol? Available Options: ${this.substanceOptions.map(opt => opt.label).join(', ')}`,
                        A6: this.patient.substanceUse,

                        Q7: `Do you currently have, or have you ever been diagnosed with, any of the following conditions? Available Options: ${this.medicalConditions.map(cond => cond.label).join(', ')}`,
                        A7: this.formatArrayResponse(this.patient.conditions, this.medicalConditions),

                        Q8: `Do you take any of the following medications? Available Options: ${this.medications.map(med => med.label).join(', ')}`,
                        A8: this.formatArrayResponse(this.patient.currentMedications, this.medications),

                        Q9: "Informed Consent",
                        A9: this.patient.consent === 'accept' ? "Patient has acknowledged and consented" : "Patient has declined consent"
                    },
                    patientInfo: {
                        height: `${this.patient.height.feet}'${this.patient.height.inches}"`,
                        weight: `${this.patient.weight} lbs`,
                        bmi: this.patient.bmi?.toFixed(1),
                        goals: this.formatGoals(),
                        healthRatings: {
                            cardiovascular: this.patient.cardiovascularRating,
                            strength: this.patient.strengthRating
                        },
                        submissionDate: new Date().toISOString()
                    },
                    pharmacyId: "",
                    masterId: `visit_${Date.now()}`,
                    company: "newSelf",
                    visitType: "sermorelin"
                };

                const response = await this.$axios.post(
                    `${this.baseUrl}/forms/assessment-form/sermorelin/${this.$route.params.id}`, 
                    formattedData
                );

                if (response.data.status === 'success') {
                    this.$router.push('/success');
                } else {
                    throw new Error('Form submission failed');
                }
            } catch (error) {
                console.error('Form submission error:', error);
                alert('There was an error submitting your form. Please try again.');
            } finally {
                this.loading = false;
            }
        },

        // Helper methods for formatting responses
        formatGoals() {
            if (!this.patient.goals || this.patient.goals.length === 0) {
                return "No goals selected";
            }

            return this.patient.goals.map(goalId => {
                const goal = this.treatmentGoals.find(g => g.id === goalId);
                if (goalId === 'other') {
                    return `Other: ${this.patient.otherGoal}`;
                }
                return goal?.label;
            }).filter(Boolean).join('; ');
        },

        formatArrayResponse(selectedIds, optionsArray) {
            if (!selectedIds || selectedIds.length === 0) {
                return "None selected";
            }

            return selectedIds.map(id => {
                const option = optionsArray.find(opt => opt.id === id);
                return option?.label;
            }).filter(Boolean).join('; ');
        }
    },
    computed: {
        formProgress() {
            return Math.round((this.questionId / 9) * 100)
        },
        isFormValid() {
            return (
                this.patient.goals.length > 0 &&
                this.patient.cardiovascularRating &&
                this.patient.strengthRating &&
                this.patient.bmi &&
                this.patient.pregnancyStatus &&
                this.patient.substanceUse &&
                (this.patient.conditions.length > 0 || this.patient.conditions.includes('none')) &&
                (this.patient.currentMedications.length > 0 || this.patient.currentMedications.includes('none')) &&
                this.patient.consent
            )
        }
    },
    watch: {
        questionId() {
            this.scrollToTop()
        }
    },
    mounted() {
        this.setSexOnUser();
        this.scrollToTop()
    }
}
</script>

<style scoped>
textarea.w-input, textarea.w-select {
    height: auto;
    width: 100%;
    border: 1px solid #dfdfdf;
    border-radius: 9px;
    margin-top: 10px;
}
.bmi-result {
    margin: 20px 0;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 4px;
    text-align: center;
    font-size: 1.2em;
    font-weight: bold;
}

.consent-text {
    max-height: 400px;
    overflow-y: auto;
    padding: 20px;
    border-radius: 4px;
    margin-bottom: 20px;
    line-height: 1.6;
}
</style>
